import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import { Button } from "../components/ui/button";
import { Bell, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  const load = () => api.get("/notifications").then((r) => setItems(r.data));
  useEffect(() => { load(); }, []);

  const markRead = async (id) => { await api.post(`/notifications/${id}/read`); load(); };
  const markAll = async () => { await api.post("/notifications/read-all"); load(); };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="notifications-page">
      <Header />
      <div className="flex pt-16">
        <Sidebar />
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          <div className="flex items-center justify-between">
            <div>
              <div className="text-[11px] uppercase tracking-widest font-bold text-orange-600">Notifications</div>
              <h1 className="font-display font-extrabold text-3xl text-slate-900 tracking-tight">Activité</h1>
            </div>
            <Button variant="outline" onClick={markAll} data-testid="mark-all-read"><CheckCheck className="h-4 w-4 mr-2" />Tout marquer lu</Button>
          </div>

          <div className="mt-6 bg-white border border-slate-200 rounded-md divide-y divide-slate-200" data-testid="notifications-list">
            {items.length === 0 && <div className="p-10 text-center text-slate-400"><Bell className="h-8 w-8 mx-auto mb-2" /><div className="text-sm">Aucune notification.</div></div>}
            {items.map((n) => (
              <div key={n.notif_id} className={`p-4 flex items-start gap-3 ${!n.read ? "bg-orange-50/50" : ""}`}>
                <span className={`h-2 w-2 mt-2 rounded-full ${!n.read ? "bg-orange-600" : "bg-slate-300"}`} />
                <div className="flex-1 min-w-0">
                  <div className="font-display font-bold text-slate-900 text-sm">{n.title}</div>
                  {n.body && <p className="text-xs text-slate-600 mt-0.5 whitespace-pre-wrap">{n.body}</p>}
                  <div className="text-[11px] text-slate-400 mt-1">{new Date(n.created_at).toLocaleString("fr-FR")}</div>
                </div>
                <div className="flex items-center gap-2">
                  {n.link && <Link to={n.link} className="text-xs text-orange-600 font-semibold">Ouvrir</Link>}
                  {!n.read && <button onClick={() => markRead(n.notif_id)} className="text-xs text-slate-500 hover:text-slate-800">Marquer lu</button>}
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}
